import { Link, NavLink } from 'react-router-dom';
import usePermissions from '../auth/usePermissions';
import useIsMobile from '../auth/useIsMobile';
import Logo from './Logo';
import { NAV, PINNED_NAV, filterNav } from './navItems';

export default function Sidebar() {
  // Capability flags (includes per-user overrides) decide which nav links show.
  const perms = usePermissions();
  const isMobile = useIsMobile();

  const renderLink = (n) => (
    <NavLink
      key={n.to}
      to={n.to}
      className={({ isActive }) =>
        `sidebar-link${isActive ? ' active' : ''}`
      }
    >
      {n.label}
    </NavLink>
  );

  return (
    <aside className="sidebar">
      <div className="sidebar-brand">
        {/* Click the brand logo to jump home — standard web convention,
            and a quick escape hatch from any deep detail page. Styled to
            look exactly like the static logo (no underline, inherit
            color) so it still reads as branding, not a nav link. */}
        <Link
          to="/dashboard"
          aria-label="Go to Dashboard"
          style={{
            display: 'inline-flex',
            textDecoration: 'none',
            color: 'inherit',
          }}
        >
          <Logo size={62} />
        </Link>
      </div>
      <nav className="sidebar-nav">
        {filterNav(NAV, perms, isMobile).map(renderLink)}
      </nav>
      {/* Pinned group: pushed to the bottom via margin-top:auto. Divider
          line separates it from the scrolling main nav above. */}
      <nav className="sidebar-nav sidebar-nav-pinned">
        {filterNav(PINNED_NAV, perms).map(renderLink)}
      </nav>
    </aside>
  );
}
